export enum AceMemberBusinessTitleEnum {
  PARTNER_ACCOUNT_MANAGER = 'PartnerAccountManager',
  OPPORTUNITY_OWNER = 'OpportunityOwner',
}
